var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9413 42.2119L36.3613 48.7919",
    stroke: "#D1D9E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9413 48.7919L36.3613 42.2119",
    stroke: "#D1D9E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3505 25.3651C28.1172 25.3418 27.8372 25.3418 27.5805 25.3651C22.0272 25.1785 17.6172 20.6285 17.6172 15.0285C17.6172 9.31179 22.2372 4.66846 27.9772 4.66846C33.6938 4.66846 38.3372 9.31179 38.3372 15.0285C38.3138 20.6285 33.9038 25.1785 28.3505 25.3651Z",
    stroke: "#D1D9E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9836 50.8915C23.7369 50.8915 19.5136 49.8182 16.2936 47.6715C10.6469 43.8915 10.6469 37.7315 16.2936 33.9749C22.7103 29.6815 33.2336 29.6815 39.6503 33.9749",
    stroke: "#D1D9E2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.8e77f81eb8d1e837a3bfd6b87f8fdca7.svg";
export { ForwardRef as ReactComponent };